module.exports = __webpack_public_path__ + "static/img/8-bg.695e29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/8-bg.png
// module id = NOqL
// module chunks = 0